import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoFooter from "../../assets/logoFooter.png";
import { getFirestore } from "../../config/firebase";
import { saveUtmParams } from "../../config/whatsappConfig";

const Footer = ({ bg }) => {
  // Procesar UTM parameters usando la función centralizada
  useEffect(() => {
    saveUtmParams();
  }, []);

  const query = new URLSearchParams(window.location.search);
  const utm_source = query && query.get("utm_source");
  const utm_medium = query && query.get("utm_medium");

  let utms = "";
  if (utm_source !== null && utm_medium !== null) {
    utms = `?utm_source=${utm_source}&utm_medium=${utm_medium}`;
  }

  /* sessionStorage.setItem('saludo', 'Bienvenidos a localStorage');
  valor = sessionStorage.getItem('saludo');
  */

  const [redesSociales, setRedesSociales] = useState([]);

  useEffect(() => {
    // Función para cargar datos desde localStorage o Firebase
    const cargarDatos = async () => {
      // Verificar si los datos ya están en localStorage
      const datosLocales = sessionStorage.getItem("redesSociales");
      if (datosLocales) {
        // Parsear los datos de localStorage y establecerlos en el estado
        setRedesSociales(JSON.parse(datosLocales));
      } else {
        // Si no están en localStorage, obtenerlos de Firebase
        const db = getFirestore();
        try {
          const datos = await db.collection("ford-informacion").get();
          const arrayDatos = datos.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setRedesSociales(arrayDatos[0]);
          // Almacenar los datos en localStorage
          sessionStorage.setItem("redesSociales", JSON.stringify(arrayDatos[0]));
        } catch (error) {
          console.log(error);
        }
      }
    };

    // Llamar a la función para cargar datos
    cargarDatos();
  }, []);

  return (
    <>
      <Container fluid className="footer mt-4">
        <Container>
          <Row>
            <div>
              <Col
                md={12}
                xs={12}
                className="text-sm-start text-center pt-3 d-flex align-items-center gap-5 columnas-foots-centrar-mobile"
              >
                <Link to={`/${utms}`}>
                  <img src={logoFooter} alt="Montironi Peugeot" className="img-fluid" />
                </Link>
                <p className="legal ocultar-mobile-legal">
                  El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                  parcial o total sin previo aviso.
                </p>
              </Col>
              <Col md={12} xs={12} className=" pt-3 social d-flex align-items-center columna-seguinos-en">
                <p>Seguinos en:</p>
                <div>
                  {redesSociales.redes &&
                    redesSociales.redes.map((red) => {
                      return red.disponible ? (
                        <a href={red.url} target="_blank" rel="noreferrer" className="px-2">
                          <img src={red.url_icon} alt="Logo" />
                        </a>
                      ) : null;
                    })}
                </div>
              </Col>
              <Col md={12} xs={12} className=" pt-3 social d-flex align-items-center mostrar-mobile-legal">
                <p className="legal">
                  El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                  parcial o total sin previo aviso.
                </p>
              </Col>
            </div>
          </Row>
        </Container>
      </Container>
      <Container fluid className="copyright">
        <Container>
          <Row>
            <Col md={12} xs={12} className="text-center">
              <p>Copyright © 2023 Montironi Ford - Todos los derechos reservados - Políticas de Seguridad</p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default Footer;
